<script setup>
// главная страница
import TheContract from "@/components/Admin/TheContract";
import TheCertificate from "@/components/Admin/TheCertificate";
import TheStatus from "@/components/Admin/TheStatus";
import {computed} from 'vue'
import {useStore} from "vuex";
const store = useStore()
const user = computed( () => {return store.getters['authModule/user']})
const activeComponent = computed( () => {
  if (+user.value.type === 1 || +user.value.type === 2){
    return TheContract
  } else if (+user.value.type === 3) {
    return TheCertificate
  } else if (+user.value.type === 0) {
    return TheStatus
  } else {
    return null
  }
})
</script>

<template>
  <main class="content-wrapper" v-if="user">
      <component :is="activeComponent"></component>
  </main>
</template>